export default __webpack_public_path__ + "static/media/mapMarker-blue.bb1d872e.svg";